module.exports = __webpack_public_path__ + "static/media/book.8c09af48.svg";